import React, { useState, useRef, useContext, useEffect } from 'react';
import { coreAxios } from "utilities/axios";
import { Divider } from 'primereact/divider';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { MasterButton } from "components/Buttons/MasterButton";
import  DeleteModalTwo  from "components/Modal/DeleteModalTwo";
import { useSelector, useDispatch } from "react-redux";
import { TableDetail } from 'components/Table/TableDetail';
//NEW
import AuthContext from  "../../context/AuthContext";
import { InputField } from "components/InputField/Input";
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { useFormik } from "formik";
import { ChallanTableForm } from 'components/Table/ChallanTableForm';
import { TablePagination } from 'components/Table/TablePagination';
import { Table } from 'components/Table/Table';
import { NameColumn, TextColumn } from 'components/Table/ColumnTemplates/CustomColumn';
import { RequisitionValidationSchema } from 'utilities/ValidationSchema/RequisitionValidationSchema';
import useAssignmentDataTable from './hook/useAssignmentDataTable';
import useMaintenanceDataTable from './hook/useMaintenanceDataTable';
import { toast as TOAST } from 'react-toastify';
import { AddAsset, UpdateAsset, GetAssetList, GetAssetDetail, DeleteAsset } from 'services/asset/asset.service';
import { DeleteAssignment } from 'services/assignment/assignment.service';
import { DeleteMaintenance } from 'services/maintenance/maintenance.service';
import { GetVendorNameList } from 'services/vendor/vendor.service';
import { GetBrandList } from 'services/other/brand.service';
import { GetCPUList } from 'services/other/cpu.service';
import { GetGenList } from 'services/other/gen.service';
import { GetMemoryList } from 'services/other/memory.service';
import { GetHDDList } from 'services/other/hdd.service';
import { GetSSDList } from 'services/other/ssd.service';
import { GetColorList } from 'services/other/color.service';
import { GetGPUList } from 'services/other/gpu.service';
import { GetDisplayList } from 'services/other/display.service';
import { GetCategoryList } from 'services/other/category.service';
import { GetPermissions } from 'services/user/user.service';
import { GetEmployeeNameList } from 'services/employee/employee.service';
import './ViewDemo.css';
const BASE_URL = process.env.REACT_APP_MAIN_URL


const Asset = () => {
    const toast = useRef(null);

    const [updateData, setUpdateData] = useState(null); // * state for update data
    const [showDetail, setShowDetail] = useState(false); //* state for form modal
    const { assetAdd } = useSelector((state) => state.assetAdd);
    const { assetUpdate } = useSelector((state) => state.assetUpdate);
    const { assetList } = useSelector((state) => state.assetList);
    const { assetDetail, assetDetailLoading } = useSelector((state) => state.assetDetail);
    const { vendorNameList } = useSelector((state) => state.vendorNameList);
    const { brandList, brandListLoading } = useSelector((state) => state.brandList);
    const { categoryList, categoryListLoading } = useSelector((state) => state.categoryList);
    const { employeeNameList } = useSelector((state) => state.employeeNameList);

    const { cpuList } = useSelector((state) => state.cpuList);
    const { genList } = useSelector((state) => state.genList);
    const { memoryList } = useSelector((state) => state.memoryList);
    const { hddList } = useSelector((state) => state.hddList);
    const { ssdList } = useSelector((state) => state.ssdList);
    const { colorList } = useSelector((state) => state.colorList);
    const { gpuList } = useSelector((state) => state.gpuList);
    const { displayList } = useSelector((state) => state.displayList);


    const dispatch = useDispatch();

    // Get FrontEndPermission
    const { permissionList, permissionListLoading } = useSelector((state) => state.permissionList);
    // Get Asset List
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);

    const [autoCategoryFilteredValue, setAutoCategoryFilteredValue] = useState([]);
    const [autoBrandFilteredValue, setAutoBrandFilteredValue] = useState([]);
    const [autoVendorFilteredValue, setAutoVendorFilteredValue] = useState([]);
    const [autoCPUFilteredValue, setAutoCPUFilteredValue] = useState([]);
    const [autoGenFilteredValue, setAutoGenFilteredValue] = useState([]);
    const [autoMemoryFilteredValue, setAutoMemoryFilteredValue] = useState([]);
    const [autoHDDFilteredValue, setAutoHDDFilteredValue] = useState([]);
    const [autoSSDFilteredValue, setAutoSSDFilteredValue] = useState([]);
    const [autoColorFilteredValue, setAutoColorFilteredValue] = useState([]);
    const [autoGPUFilteredValue, setAutoGPUFilteredValue] = useState([]);
    const [autoDisplayFilteredValue, setAutoDisplayFilteredValue] = useState([]);

    const [date, setDate] =useState(new Date());
    const [selectedData, setSelectedData] = useState([])
    const [showForm, setShowForm] = useState(false); //* state for form modal
    // hook
    const [deleteAssignmentID, setDeleteAssignmentID] = useState();
    const [showDeleteAssignmentModal, setShowDeleteAssignmentModal] = useState(false);
    const [deleteMaintenanceID, setDeleteMaintenanceID] = useState();
    const [showDeleteMaintenanceModal, setShowDeleteMaintenanceModal] = useState(false);

    const { user } = useContext(AuthContext);

    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        serial_no: "",
        model_no: "",
        category: "",
        brand: "",
        vendor: "",
        description: "",
        purchase_date: "",
        purchase_cost: "",
        is_maintenance: "",
        is_archived: "",
        is_warranty: "",
        warranty_date_from: "",
        warranty_date_till: "",
        cpu: "",
        gen: "",
        memory: "",
        hdd: "",
        ssd: "",
        color: "",
        gpu: "",
        display: "",
        assignment: [
            {
                id: 0,
                assign_to: "",
                assign_date: date,
                return_date: "",
                remark: "",
            },
        ],
        maintenance: [
            {
                id: 0,
                vendor: "",
                immediate_user: "",
                send_date: date,
                receive_date: "",
                issue: "",
            }
        ]
    };

    const updateInitialValue = {
        ...assetDetail,
        category: categoryList?.find((value) => value.id === assetDetail?.category) || "",
        brand: brandList?.find((value) => value.id === assetDetail?.brand) || "",
        vendor: vendorNameList?.find((value) => value.id === assetDetail?.vendor) || "",
        purchase_date: assetDetail?.purchase_date ? new Date(assetDetail?.purchase_date) : "",
        warranty_date_from: assetDetail?.warranty_date_from ? new Date(assetDetail?.warranty_date_from) : "",
        warranty_date_till: assetDetail?.warranty_date_till ? new Date(assetDetail?.warranty_date_till) : "",
        assignment: assetDetail?.assignment?.length == 0 ? [
            {
                id: 0,
                assign_to: "",
                assign_date: date,
                return_date: "",
                remark: "",
            }
        ] : assetDetail?.assignment?.map((value) =>{
            return {
                ...value,
                assign_to: employeeNameList?.find((emp) => emp.id === value?.assign_to) || "",
                assign_date: new Date(value?.assign_date),
                return_date: value?.return_date ? new Date(value?.return_date) : "",
            }
        }),
        maintenance: assetDetail?.maintenance?.length == 0 ? [
            {
                id: 0,
                vendor: "",
                immediate_user: "",
                send_date: date,
                receive_date: "",
                issue: "",
            }
        ] : assetDetail?.maintenance?.map((value) =>{
            return {
                ...value,
                vendor: vendorNameList?.find((ven) => ven.id === value?.vendor) || "",
                immediate_user: employeeNameList?.find((emp) => emp.id === value?.immediate_user) || "",
                send_date: new Date(value?.send_date),
                receive_date: value?.receive_date ? new Date(value?.receive_date) : "",
            }
        }),
    };

    const formik = useFormik({
        initialValues: updateData ? updateInitialValue : createInitialValue,
        // validationSchema: RequisitionValidationSchema, // * yup schema validation
        onSubmit: (values) => {
            const modifiedData = {
                ...values,
                category: values?.category?.id || 0,
                brand: values?.brand?.id || 0,
                vendor: values?.vendor?.id || '',
                purchase_cost: parseFloat(values?.purchase_cost) || 0.0,
                is_maintenance: values?.is_maintenance == 1 ? true : false,
                is_archived: values?.is_archived == 1 ? true : false,
                is_warranty: values?.is_warranty == 1 ? true : false,
                cpu: values?.cpu?.name || '',
                gen: values?.gen?.name || '',
                memory: values?.memory?.name || '',
                hdd: values?.hdd?.name || '',
                ssd: values?.ssd?.name || '',
                color: values?.color?.name || '',
                gpu: values?.gpu?.name || '',
                display: values?.display?.name || '',
                assignment: values.assignment.map((values) => {
                    return{
                        ...values,
                        assign_to: values?.assign_to?.id || 0,
                    }
                }),
                maintenance: values.maintenance.map((values) => {
                    return{
                        ...values,
                        vendor: values?.vendor?.id || 0,
                        immediate_user: values?.immediate_user?.id || 0,
                    }
                }),
            }
            handelSubmit(modifiedData);
        },
        enableReinitialize: true,
    });

    const { modalAssignmentTableColumns, modalAssignmentTableActionButton } = useAssignmentDataTable(
        formik, 
        setDeleteAssignmentID, 
        setShowDeleteAssignmentModal, 
        showForm,
        setShowForm, 
        setUpdateData,
    );

    const { modalMaintenanceTableColumns, modalMaintenanceTableActionButton } = useMaintenanceDataTable(
        formik, 
        setDeleteMaintenanceID, 
        setShowDeleteMaintenanceModal, 
        setShowForm, 
        setUpdateData,
    );

    const updateAsset = async (asset) => {
        await dispatch(GetAssetDetail(asset?.id))
        // await dispatch(GetEmployeeNameList());
        setShowForm(true); // * set the form to true
        setUpdateData(assetDetail);
    };

    const confirmDeleteAssignmentDetail = async () => {
        const { id, asset } = deleteAssignmentID;
        await dispatch(DeleteAssignment(id)); //calling
        // setUpdateData(chalan);
        setShowDeleteAssignmentModal(false);
        await dispatch(GetAssetDetail(asset))
        // await dispatch(GetRequisitionItems(asset)); //calling
    };

    const confirmDeleteMaintenanceDetail = async () => {
        const { id, asset } = deleteMaintenanceID;
        await dispatch(DeleteMaintenance(id)); //calling
        setShowDeleteMaintenanceModal(false);
        await dispatch(GetAssetDetail(asset))
    };

    const DeleteModal =  (event, id) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this record?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                await dispatch(DeleteAsset(id));
                fetchData();
            },
            reject: () => {
                toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    };

    // form submit handler
    const handelSubmit = async (values) => {
        if(updateData){
            await dispatch(UpdateAsset(values)).then(() => {
                hideModal();
            });
            return
        }
        await dispatch(AddAsset(values)).then(() => {
            hideModal();
            return
        });
    };

    const assetDetails = async (asset) => {
        setShowDetail(true); // * set the form to true
        // dispatch(GetChalanDetail(asset?.id))
        await dispatch(GetAssetDetail(asset))
    };

    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
        setShowDetail(false);
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    // Call always on render
    useEffect(() => {
        dispatch(GetPermissions());
    }, [user, ])

    useEffect(() => {
        if (showForm){
            dispatch(GetCategoryList());
            dispatch(GetBrandList());
            dispatch(GetCPUList());
            dispatch(GetGenList());
            dispatch(GetMemoryList());
            dispatch(GetHDDList());
            dispatch(GetSSDList());
            dispatch(GetColorList());
            dispatch(GetGPUList());
            dispatch(GetDisplayList());
        }
    }, [showForm, ])

    useEffect(() => {
        fetchData();
      }, [currentPage, assetAdd, assetUpdate]);
    
    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await coreAxios.get(`${BASE_URL}/api/asset-list/?page=${currentPage}`);
            setData(response.data);
            setTotalRecords(response.data?.count);
        } catch (error) {
            console.error('Error fetching data: ', error);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (event) => {
        setCurrentPage(event.page + 1);
    };

    // columns of the table with header name
    const tableColumns = [
        { field: "serial_no", header: "Serial No", sortableBody: NameColumn },
        { field: "model_no", header: "Model No", sortableBody: TextColumn },
        { field: "category_name", header: "Category", sortableBody: TextColumn },
        { field: "brand_name", header: "Brand", sortableBody: TextColumn },
        { field: "vendor_name", header: "Vendor", sortableBody: TextColumn },
        { field: "purchase_cost", header: "Purchase Cost", sortableBody: TextColumn },
        { field: "purchase_date", header: "Purchase Date", sortableBody: TextColumn },
        { field: "last_assign_user", header: "Current User", sortableBody: TextColumn },
    ];

    const detailTableColumns = [
        { field: "sl", header: "SL", sortableBody: NameColumn },
        { field: "name", header: "Name", sortableBody: TextColumn },
        { field: "quantity", header: "Quantity", sortableBody: TextColumn },
        { field: "color", header: "Color", sortableBody: TextColumn },
        { field: "size", header: "Size", sortableBody: TextColumn },
        { field: "purpose", header: "Purpose", sortableBody: TextColumn },
        { field: "remark", header: "Remark", sortableBody: TextColumn },
    ];

    const searchCategory = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && categoryList !== undefined) {
                setAutoCategoryFilteredValue([...categoryList]);
            } else {
                setAutoCategoryFilteredValue(
                    categoryList?.filter((category) => {
                        return category.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchBrand = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && brandList !== undefined) {
                setAutoBrandFilteredValue([...brandList]);
            } else {
                setAutoBrandFilteredValue(
                    brandList?.filter((brand) => {
                        return brand.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchVendor = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && vendorNameList !== undefined) {
                setAutoVendorFilteredValue([...vendorNameList]);
            } else {
                setAutoVendorFilteredValue(
                    vendorNameList?.filter((vendor) => {
                        return vendor.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchCPU = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && cpuList !== undefined) {
                setAutoCPUFilteredValue([...cpuList]);
            } else {
                setAutoCPUFilteredValue(
                    cpuList?.filter((cpu) => {
                        return cpu.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchGen = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && genList !== undefined) {
                setAutoGenFilteredValue([...genList]);
            } else {
                setAutoGenFilteredValue(
                    genList?.filter((gen) => {
                        return gen.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchMemory = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && memoryList !== undefined) {
                setAutoMemoryFilteredValue([...memoryList]);
            } else {
                setAutoMemoryFilteredValue(
                    memoryList?.filter((memory) => {
                        return memory.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchHDD = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && hddList !== undefined) {
                setAutoHDDFilteredValue([...hddList]);
            } else {
                setAutoHDDFilteredValue(
                    hddList?.filter((hdd) => {
                        return hdd.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchSSD = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && ssdList !== undefined) {
                setAutoSSDFilteredValue([...ssdList]);
            } else {
                setAutoSSDFilteredValue(
                    ssdList?.filter((ssd) => {
                        return ssd.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchColor = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && colorList !== undefined) {
                setAutoColorFilteredValue([...colorList]);
            } else {
                setAutoColorFilteredValue(
                    colorList?.filter((color) => {
                        return color.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchGPU = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && gpuList !== undefined) {
                setAutoGPUFilteredValue([...gpuList]);
            } else {
                setAutoGPUFilteredValue(
                    gpuList?.filter((gpu) => {
                        return gpu.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchDisplay = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && displayList !== undefined) {
                setAutoDisplayFilteredValue([...displayList]);
            } else {
                setAutoDisplayFilteredValue(
                    displayList?.filter((display) => {
                        return display.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    // * input data array of object for the form / modal
    const inputData = [
        {
            id: "category",
            name: "category",
            type: "select",
            labelFor: "category",
            label: "Select Category",
            required: true,
            className: "col-12 md:col-2",
            autoFilteredValue: autoCategoryFilteredValue,
            autoCompleteMethod: searchCategory,
            selectedAutoValue: categoryList,
        },
        {
            id: "brand",
            name: "brand",
            type: "select",
            labelFor: "brand",
            label: "Select Brand",
            required: true,
            className: "col-12 md:col-2",
            autoFilteredValue: autoBrandFilteredValue,
            autoCompleteMethod: searchBrand,
            selectedAutoValue: brandList,
        },
        {
            id: "model_no",
            name: "model_no",
            value: "model_no",
            type: "text",
            labelFor: "model_no",
            label: "Model No",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-2",
        },
        {
            id: "serial_no",
            name: "serial_no",
            value: "serial_no",
            type: "text",
            labelFor: "serial_no",
            label: "Serial No",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-2",
        },
        {
            id: "vendor",
            name: "vendor",
            type: "select",
            labelFor: "vendor",
            label: "Select Vendor",
            required: false,
            className: "col-12 md:col-2",
            autoFilteredValue: autoVendorFilteredValue,
            autoCompleteMethod: searchVendor,
            selectedAutoValue: vendorNameList,
        },
        {
            id: "purchase_date",
            name: "purchase_date",
            value: "purchase_date",
            type: "date",
            labelFor: "purchase_date",
            label: "Purchase Date",
            required: false,
            messagePosition: 'bottom',
            className: "col-12 md:col-2",
        },
        {
            id: "purchase_cost",
            name: "purchase_cost",
            value: "purchase_cost",
            type: "text",
            labelFor: "purchase_cost",
            label: "Purchase Cost",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-2",
        },
        {
            id: "is_warranty",
            name: "is_warranty",
            type: "switch",
            labelFor: "Is Warranty",
            label: "Is Warranty?",
            required: true,
            className: "col-12 md:col-2",
            switchChecked: Boolean(formik.values.is_warranty),
            setSwitchChecked: (e) => formik.setFieldValue("is_warranty", Number(e.value)),
        },
        {
            id: "warranty_date_from",
            name: "warranty_date_from",
            value: "warranty_date_from",
            type: "date",
            labelFor: "warranty_date_from",
            label: "Warranty Date From",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-2",
        },
        {
            id: "warranty_date_till",
            name: "warranty_date_till",
            value: "warranty_date_till",
            type: "date",
            labelFor: "warranty_date_till",
            label: "Warranty Date Till",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-2",
        },
        {
            id: "is_archived",
            name: "is_archived",
            type: "switch",
            labelFor: "Is Archived",
            label: "Is Archived?",
            required: true,
            className: "col-12 md:col-2",
            switchChecked: Boolean(formik.values.is_archived),
            setSwitchChecked: (e) => formik.setFieldValue("is_archived", Number(e.value)),
        },
        {
            id: "is_maintenance",
            name: "is_maintenance",
            type: "switch",
            labelFor: "Under Maintenance",
            label: "Under Maintenance?",
            required: true,
            className: "col-12 md:col-2",
            switchChecked: Boolean(formik.values.is_maintenance),
            setSwitchChecked: (e) => formik.setFieldValue("is_maintenance", Number(e.value)),
        },
    ];

    const descriptionInput = [
        {
            id: "description",
            name: "description",
            value: "description",
            type: "textarea",
            labelFor: "description",
            label: "Description",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-12",
        },
    ];

    const extraInputs = [
        {
            id: "cpu",
            name: "cpu",
            type: "select",
            labelFor: "cpu",
            label: "Select CPU",
            required: false,
            className: "col-12 md:col-2",
            autoFilteredValue: autoCPUFilteredValue,
            autoCompleteMethod: searchCPU,
            selectedAutoValue: cpuList,
        },
        {
            id: "gen",
            name: "gen",
            type: "select",
            labelFor: "gen",
            label: "Select Gen",
            required: false,
            className: "col-12 md:col-2",
            autoFilteredValue: autoGenFilteredValue,
            autoCompleteMethod: searchGen,
            selectedAutoValue: genList,
        },
        {
            id: "memory",
            name: "memory",
            type: "select",
            labelFor: "memory",
            label: "Select Memory",
            required: false,
            className: "col-12 md:col-2",
            autoFilteredValue: autoMemoryFilteredValue,
            autoCompleteMethod: searchMemory,
            selectedAutoValue: memoryList,
        },
        {
            id: "hdd",
            name: "hdd",
            type: "select",
            labelFor: "hdd",
            label: "Select HDD",
            required: false,
            className: "col-12 md:col-2",
            autoFilteredValue: autoHDDFilteredValue,
            autoCompleteMethod: searchHDD,
            selectedAutoValue: hddList,
        },
        {
            id: "ssd",
            name: "ssd",
            type: "select",
            labelFor: "ssd",
            label: "Select SSD",
            required: false,
            className: "col-12 md:col-2",
            autoFilteredValue: autoSSDFilteredValue,
            autoCompleteMethod: searchSSD,
            selectedAutoValue: ssdList,
        },
        {
            id: "color",
            name: "color",
            type: "select",
            labelFor: "color",
            label: "Select Color",
            required: false,
            className: "col-12 md:col-2",
            autoFilteredValue: autoColorFilteredValue,
            autoCompleteMethod: searchColor,
            selectedAutoValue: colorList,
        },
        {
            id: "gpu",
            name: "gpu",
            type: "select",
            labelFor: "gpu",
            label: "Select GPU",
            required: false,
            className: "col-12 md:col-2",
            autoFilteredValue: autoGPUFilteredValue,
            autoCompleteMethod: searchGPU,
            selectedAutoValue: gpuList,
        },
        {
            id: "display",
            name: "display",
            type: "select",
            labelFor: "display",
            label: "Select Display",
            required: false,
            className: "col-12 md:col-2",
            autoFilteredValue: autoDisplayFilteredValue,
            autoCompleteMethod: searchDisplay,
            selectedAutoValue: displayList,
        },
    ];

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    {
                        permissionList[0]?.update_permissions.includes(user?.user_type) ? 
                        <>
                            <Button 
                                tooltip="Update" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
                                icon="pi pi-pencil" className="p-button-rounded p-button-primary mr-2" onClick={() => updateAsset(rowData)} 
                            />
                        </> : <></>
                    }
                    {
                        // <Button 
                        // icon="pi pi-list" 
                        // className="p-button-outlined p-button-info mr-2" 
                        // onClick={(e) => {
                        //     assetDetails(rowData)
                        // }}
                        // />
                    }
                    {
                        permissionList[0]?.delete_permissions.includes(user?.user_type) ? 
                        <>
                            <Toast ref={toast} /> 
                            <ConfirmPopup />
                            <Button 
                                tooltip="Delete" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
                                icon="pi pi-trash" className="p-button-rounded p-button-warning mr-2" 
                                onClick={(e) => { DeleteModal(e, rowData.id); }} 
                                disabled= {false} 
                            />
                        </> : <></>
                    }  
                </div>
            </>
        );
    }

    return (
        <>
            <Table
                tableHeaderName="IT Assets"
                tableColumns={tableColumns}
                data={data}
                loading={loading}
                dataKey="id"
                actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
                //Search
                searchField
                //Row select
                isRowSelectable={false}
                rows={50}
                scrollable
                scrollHeight = '700px'
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                //Toolbar
                exportBtn={false}
                toolbarPermissions={permissionList[0]}
                //Pagination
                // totalRecords={totalRecords}
                // onPageChange={onPageChange}
            />
            <Dialog
                visible={showForm}
                style={{ width: "1400px" }}
                header={`${updateData ? "Update" : "Create"} IT Asset`}
                className="p-fluid"
                onHide={hideModal}
                position="top"
                modal closeOnEscape blockScroll icons focusOnShow resizable maximizable
            >
                <form onSubmit={formik.handleSubmit} className={`grid grid-cols-4 mt-2 gap-x-3`}>
                    {inputData.map(({ id, name, value, type, labelFor, label, required, rows, className, autoCompleteMethod, autoFilteredValue, onBlur, onChange, errors, ...rest }) => (

                        <div key={id} className={`p-field ${className}`} >
                            <InputField
                                id={id}
                                type={type}
                                required={required}
                                name={name}
                                errors={errors || formik.errors?.[id]?.id || formik.errors[id]}
                                label={label}
                                labelFor={labelFor}
                                rows={rows}
                                value={formik.values[name]}
                                autoCompleteMethod={autoCompleteMethod}
                                autoFilteredValue={autoFilteredValue}
                                onChange={(...args) => {
                                    !onChange && formik.handleChange(...args);
                                    onChange?.(...args);
                                }}
                                onBlur={onBlur}
                                onClose={() => formik.setErrors({})}
                                {...rest}
                            />
                        </div>
                    ))}
                    <>
                        {
                            (formik?.values?.category?.['name'] == "Laptop" || formik?.values?.category?.['name'] == "Desktop" || formik?.values?.category?.['name'] == "Tablet" || formik?.values?.category?.['name'] == "Monitor") ? <>
                                {extraInputs.map(({ id, name, value, type, labelFor, label, required, rows, className, autoCompleteMethod, autoFilteredValue, onBlur, onChange, errors, ...rest }) => (
                                    <div key={id} className={`p-field ${className}`} >
                                        <InputField
                                            id={id}
                                            type={type}
                                            required={required}
                                            name={name}
                                            errors={errors || formik.errors?.[id]?.id || formik.errors[id]}
                                            label={label}
                                            labelFor={labelFor}
                                            rows={rows}
                                            value={formik.values[name]}
                                            autoCompleteMethod={autoCompleteMethod}
                                            autoFilteredValue={autoFilteredValue}
                                            onChange={(...args) => {
                                                !onChange && formik.handleChange(...args);
                                                onChange?.(...args);
                                            }}
                                            onBlur={onBlur}
                                            onClose={() => formik.setErrors({})}
                                            {...rest}
                                        />
                                    </div>
                                ))}
                            </> : <></>
                        }
                    </>

                    {descriptionInput.map(({ id, name, value, type, labelFor, label, required, rows, className, autoCompleteMethod, autoFilteredValue, onBlur, onChange, errors, ...rest }) => (
                    <div key={id} className={`p-field ${className}`} >
                        <InputField
                            id={id}
                            type={type}
                            required={required}
                            name={name}
                            errors={errors || formik.errors?.[id]?.id || formik.errors[id]}
                            label={label}
                            labelFor={labelFor}
                            rows={rows}
                            value={formik.values[name]}
                            autoCompleteMethod={autoCompleteMethod}
                            autoFilteredValue={autoFilteredValue}
                            onChange={(...args) => {
                                !onChange && formik.handleChange(...args);
                                onChange?.(...args);
                            }}
                            onBlur={onBlur}
                            onClose={() => formik.setErrors({})}
                            {...rest}
                        />
                    </div>
                    ))}
                    <Divider align="center">
                        <span className="p-tag" style={{fontSize: '12px'}}>Assign Information</span>
                    </Divider>
                    <div className="col-12">
                        <div className="w-full">
                            <ChallanTableForm
                                emptyMessage="No data found"
                                tableColumns={modalAssignmentTableColumns}
                                data={formik.values.assignment}
                                loading={brandListLoading}
                                dataKey="assignmentID"
                                actionButtonWidth={10}
                                actionButton={modalAssignmentTableActionButton}
                            />
                        </div>
                    </div>
                    <Divider align="center">
                        <span className="p-tag" style={{fontSize: '12px'}}>Maintenance Information</span>
                    </Divider>
                    <div className="col-12">
                        <div className="w-full">
                            <ChallanTableForm
                                emptyMessage="No data found"
                                tableColumns={modalMaintenanceTableColumns}
                                data={formik.values.maintenance}
                                loading={categoryListLoading}
                                dataKey="maintenanceID"
                                actionButtonWidth={10}
                                actionButton={modalMaintenanceTableActionButton}
                            />
                        </div>
                    </div>
                    <MasterButton resetForm={resetForm} update={updateData} loading={loading} col1={8} col2={updateData ? 6 : 7} col3={4}/>
                    <DeleteModalTwo
                        visibleModal={showDeleteAssignmentModal}
                        header="Confirm"
                        onHide={() => setShowDeleteAssignmentModal(false)}
                        multiItem={false}
                        confirmDelete={confirmDeleteAssignmentDetail}
                        item={deleteAssignmentID}
                        loading={assetDetailLoading}
                        message="Are you sure you want to delete this Assignment item? This Cannot be undone!"
                    />
                    <DeleteModalTwo
                        visibleModal={showDeleteMaintenanceModal}
                        header="Confirm"
                        onHide={() => setShowDeleteMaintenanceModal(false)}
                        multiItem={false}
                        confirmDelete={confirmDeleteMaintenanceDetail}
                        item={deleteMaintenanceID}
                        loading={assetDetailLoading}
                        message="Are you sure you want to delete this Maintenance item? This Cannot be undone!"
                    />
                </form>
            </Dialog>
        </>
    );
};

export default Asset;
